import React from 'react';
import { Box } from '@mui/material';

const Row = () => (
  <Box display="grid" gridTemplateColumns="80px 1fr 1fr 1fr 200px" gap={2} py={1}>
    {Array.from({ length: 5 }).map((_, i) => (
      <Box key={i} height={24} bgcolor="#eee" borderRadius={1} className="mui-animate-pulse" />
    ))}
  </Box>
);

const SkeletonTable: React.FC<{ rows?: number }> = ({ rows = 8 }) => (
  <Box>
    <Box display="grid" gridTemplateColumns="80px 1fr 1fr 1fr 200px" gap={2} py={1}>
      {Array.from({ length: 5 }).map((_, i) => (
        <Box key={i} height={28} bgcolor="#f3f3f3" borderRadius={1} />
      ))}
    </Box>
    {Array.from({ length: rows }).map((_, i) => (
      <Row key={i} />
    ))}
  </Box>
);

export default SkeletonTable;


